import Plausible from "plausible-tracker";

export default class AppAnalytics {
  private static plausible: ReturnType<typeof Plausible> | null = null;

  static getPlausible() {
    if (AppAnalytics.plausible === null) {
      const plausible = Plausible({
        domain: 'vetrimedica.com',
        apiHost: 'https://straw.vetrimedica.com',
        trackLocalhost: false,
      })
      plausible.enableAutoPageviews()

      AppAnalytics.plausible = plausible
    }

    return AppAnalytics.plausible
  }
}

